export const customRequestIdleCallback =
  window.requestIdleCallback ||
  function requestIdleCallback(
    cb: CallableFunction,
    _options?: IdleRequestOptions
  ) {
    const start = Date.now();
    return setTimeout(() => {
      cb({
        didTimeout: false,
        timeRemaining() {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };
